var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M2.505 7.517a1.696 1.696 0 0 1 2.438 0L12 14.74l7.057-7.223a1.696 1.696 0 0 1 2.438 0c.673.689.673 1.806 0 2.495l-8.276 8.471c-.673.69-1.765.69-2.438 0l-8.276-8.47a1.794 1.794 0 0 1 0-2.496",
    clipRule: "evenodd"
  })));
};
export default SvgChevronDown;